import axios from "../../../services/axios-config.js";

export async function getConnectedUsers({ companyId }) {
    const res = await axios.get(`/admin/presence/companies/${companyId}/users`);
    return res?.data;
}
